import {
  BufferAttribute,
  BufferGeometry,
  Mesh,
  MeshBasicMaterial,
  Object3D,
  SphereGeometry,
} from "three";
import { Line2 } from "three/examples/jsm/lines/Line2.js";
import { LineGeometry } from "three/examples/jsm/lines/LineGeometry.js";

import { RTK_FIX_ACCURACY } from "../../../common/src/modules";

const faceGeometry = new BufferGeometry();
const facePositions = [
  // 0        1
  -1, 1, -1, 1, 1, -1,
  // 2        3
  1, -1, -1, -1, -1, -1,
];
faceGeometry.setAttribute(
  "position",
  new BufferAttribute(new Float32Array(facePositions), 3)
);
faceGeometry.setIndex([0, 1, 2, 0, 2, 3]);

const headGeometry = new SphereGeometry(1, 8, 8);
const bodyGeometry = new LineGeometry();

const bodyPositions = [...facePositions, 0, 0, 0];
const positions = [] as number[];
const indices = [0, 1, 4, 1, 4, 2, 2, 4, 3, 3, 4, 0, 0, 1, 2, 3, 0];
indices.forEach((index) => {
  positions.push(bodyPositions[index * 3]);
  positions.push(bodyPositions[index * 3 + 1]);
  positions.push(bodyPositions[index * 3 + 2]);
});

bodyGeometry.setPositions(positions);

export class Photoshot extends Object3D {
  public photoId: number;
  public photoName: string;

  public head: Mesh<BufferGeometry, MeshBasicMaterial>;
  public body: Line2;
  public face: Mesh<BufferGeometry, MeshBasicMaterial>;

  public focused: boolean = false;
  public accuracy: RTK_FIX_ACCURACY = RTK_FIX_ACCURACY.LOW;

  constructor(id: number, name: string) {
    super();
    this.photoId = id;
    this.name = "Photoshot" + id;
    this.head = new Mesh(headGeometry);
    this.body = new Line2(bodyGeometry);
    this.body.scale.set(0.05, 0.05, 0.1);
    this.face = new Mesh(faceGeometry);
    this.face.scale.set(0.05, 0.05, 0.1);
    this.add(this.head, this.body, this.face);
    this.photoName = name;
  }
}
